<!-- <div class="row">
    <div class="col-12">
        <div class="marqueeDiv">
            <marquee> {{message}}</marquee>
        </div>
    </div>
</div> -->

<div class="marquee-box">
    <h4><i class="mdi mdi-microphone-outline"></i> News </h4>
    <marquee scrollamount="5">{{message}}</marquee>
</div>